import FilterOption from "@/features/bridge-scanner/components/table/left-controls/filter-option";
import styles from "./index.module.scss";
import type { BridgeScannerFilterStoreType } from "@/features/bridge-scanner/stores/filters.store";
import type { BSFilterParamEnum } from "@/types/bridge-scanner.types";
import type { Option } from "@/features/bridge-scanner/components/table/left-controls/filter-option";

type Props = {
  header: string | null;
  filterType: BSFilterParamEnum;
  options: Option[];
  selectedOptions?: string[] | undefined;
  selectOption: BridgeScannerFilterStoreType["setQueryParams"];
};

const FilterSelector = ({
  header,
  options,
  selectedOptions,
  filterType,
  selectOption,
}: Props) => {
  return (
    <div className={styles.optionsWrapper}>
      <div className={styles.optionsListHeader}>
        {header && <span className={styles.headerText}>{header}</span>}
        {!!selectedOptions?.length && (
          <span className={styles.optionSelectionCount}>
            {selectedOptions.length}
          </span>
        )}
      </div>
      <div className={styles.optionsListContainer}>
        <ul className={styles.optionsList}>
          {options.map((option, i) => (
            <li key={i}>
              <FilterOption
                option={option}
                selectedOptions={selectedOptions}
                selectOption={selectOption}
                filterType={filterType}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FilterSelector;
